<template lang="pug">
.results-text 
	span(v-if="totalLocations > 0") Showing 
	span.results-text__showing-lower(v-if="totalLocations > 0") 1
	span(v-if="totalLocations > 0") -
	span.results-text__showing-upper(v-if="totalLocations > 0") {{ activeLocations.length }} 
	span(v-if="totalLocations > 0") of 
	span.results-text__showing-upper {{ totalLocations }} 
	span Locations found in your area.
	br
	br
	div(v-if="totalLocations == 0") 
		p There are no locations for the specified search criteria. Here are some tips that may help.
		ul
			li Check for spelling mistakes or typos.
			li Clear any location filters you may have applied.
			li Browse by State by selecting All Locations at the bottom of this page."
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "ResultCountText",
	components: {},
	data() {
		return {
			
		};
	},
	computed: {
		...mapGetters([
			"activeLocations",
			"totalLocations",
		]),
	},
	methods: {
		toggleTag() {

		},
	},
	created() {
		
	},
};
</script>


<style scoped lang="scss">
.results-text  {
	margin-bottom: 66px;
	@include mqdn(sm_dn) {
		margin-bottom: 48px;
	}
	& > div {
		@include wysiwyg;
	}
}
</style>